import { type ReactNode } from "react";
import { SessionProvider } from "./context/session-context";
import { ToastProvider, ToastContainer } from "./components/common/toast";
import { AppProvider } from "./context/app-context";
import { MultipleFileUploadProvider } from "./context/MultipleFileUploadContext";
import { QATaskProvider } from "./context/QATaskContext";
import { DashboardProvider } from "./context/DashboardContext";
import { SessionTimeoutProvider } from "./context/SessionTimeoutContext";
import { SessionTimeoutWrapper } from "./components/SessionTimeoutWrapper/SessionTimeoutWrapper";
// import { DashboardProvider } from "./context/dash-context";
// import { FormProvider } from "./context/form-context";

export default function RootLayout({ children }: { children: ReactNode }) {
  return (
    <SessionTimeoutProvider
      config={{
        idleTimeoutMs: 60 * 60 * 1000, // 1 minute inactivity (for testing)
        absoluteTimeoutMs: 8 * 60 * 60 * 1000, // 8 hours max session
        warningMs: 5 * 60 * 1000, // 5 min warning (not currently used)
      }}
    >
      <SessionProvider>
        <SessionTimeoutWrapper>
          <ToastProvider>
            <ToastContainer />
            <AppProvider>
              <DashboardProvider>
                <MultipleFileUploadProvider>
                  <QATaskProvider>{children}</QATaskProvider>
                </MultipleFileUploadProvider>
              </DashboardProvider>
            </AppProvider>
          </ToastProvider>
        </SessionTimeoutWrapper>
      </SessionProvider>
    </SessionTimeoutProvider>
  );
}
